export default {
  inject: [
    'vame'
  ],

  data () {
    return {
      tickerHandler: undefined
    }
  },

  mounted () {
    this.vame.ticker.add(this.tickerHandler = this.update.bind(this))
  },

  beforeDestroy () {
    if (this.vname && this.vname.ticker) this.vame.ticker.remove(this.tickerHandler)
  },

  methods: {
    update () {}
  }
}
